<lib-core>
    <!-- <ion-app> -->
        <div class="device-box">
            <lib-top-nav></lib-top-nav>
            <ion-content #mainContent [fullscreen]="true">
                <div class="content" [@routeAnimations]="o && o.activatedRouteData">
                    <router-outlet #o="outlet">
                    </router-outlet>
                </div>
            </ion-content>
            <lib-bottom-nav *ngIf="hideFooter" [links]="links"></lib-bottom-nav>
        </div>
    <!-- </ion-app> -->
</lib-core>